/* eslint-disable react/require-default-props */
import React from 'react';
import PropTypes from 'prop-types';

const DrawerBody = React.forwardRef((props, ref) => {

  const { ...other } = props;
  const classes = 'sui-flex-auto sui-overflow-y-auto sui-bg-primary sui-p-4';

  return (
    <div
      className={classes}
      ref={ref}
      {...other}
    />
  );
});

DrawerBody.displayName = 'DrawerBody';

DrawerBody.propTypes = {
  /**
   * The contents of the drawer
   */
  children: PropTypes.node
};

DrawerBody.defaultProps = {
};

export { DrawerBody };